import { WASMTensor } from '../../../tensor/wasm/tensor';
export function addIndexWASM(indices, axis, count) {
    return new WASMTensor(indices.wasmTensor.add_index(axis, count));
}
//# sourceMappingURL=wasm.js.map